export const isBibiUser = (type) => {
  return ['A', 'BA', 'B'].includes(type)
}

export const isSupplierUser = (type) => {
  return ['F', 'FA'].includes(type)
}